import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LogoImage from "../../assets/images/logo/logo-default-text.png";

const Logo = styled.img`
  height: 40px;
  cursor: pointer;
`;
function LogoDefaultText() {
  const navigate = useNavigate();
  return (
    <Logo
      src={LogoImage}
      alt="Peak Pashmina"
      onClick={() => {
        navigate("/");
      }}
    />
  );
}

export default LogoDefaultText;
